import React from "react";
import styled from "styled-components";

import { mediaQueries } from "src/theme/deviceBreakpoints";

/*

    DEFAULT: blue, no cancel button, confirmText

    onCancel: include onCancel if you want a cancel button
    isDisabled: state to disable the confirm button and make it grey
    isDelete: makes the confirm button bright ass RED
*/

interface FooterActionsProps {
  onCancel?: () => void;
  cancelText?: string;
  onConfirm: () => void;
  confirmText: string;
  isDisabled?: boolean;
  isConfirmDisabled?: boolean;
  isDelete?: boolean;
  isSecondaryBack?: boolean;
}

const FooterActions: React.FC<FooterActionsProps> = ({
  onCancel,
  cancelText = "Cancel",
  onConfirm,
  confirmText,
  isDisabled = false,
  isConfirmDisabled = false,
  isDelete = false,
  isSecondaryBack = true,
}) => {
  return (
    <Container>
      {onCancel &&
        (isSecondaryBack ? (
          <CancelButton onClick={onCancel} disabled={isDisabled}>
            {cancelText}
          </CancelButton>
        ) : (
          <MainCancelButton onClick={onCancel} disabled={isDisabled}>
            {cancelText}
          </MainCancelButton>
        ))}
      <ConfirmButton
        onClick={onConfirm}
        isDelete={isDelete}
        disabled={isConfirmDisabled || isDisabled}
      >
        {confirmText}
      </ConfirmButton>
    </Container>
  );
};

export default FooterActions;

const Container = styled.div<{ isSecondaryBack?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: ${({ isSecondaryBack }) =>
    isSecondaryBack ? "flex-end" : "space-between"};
  gap: 16px;

  & > :only-child {
    margin-left: auto;
  }

  ${mediaQueries.largeMobile} {
    justify-content: flex-end;
  }
`;

const CancelButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
  padding: 10px 20px;
  cursor: pointer;
`;

const MainCancelButton = styled.button`
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.globalConstants.color.backgroundGrayDark : undefined};
  font-weight: 700;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  border: ${({ theme }) =>
    `1px solid ${theme.globalConstants.color.borderGray}`};
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
    cursor: not-allowed;
  }
`;

const ConfirmButton = styled.button<{ isDelete?: boolean }>`
  background-color: ${({ theme, isDelete, disabled }) =>
    isDelete
      ? theme.globalConstants.color.backgroundDanger
      : disabled
      ? theme.globalConstants.color.backgroundGrayDark
      : theme.globalConstants.color.backgroundPrimary};
  font-weight: 700;
  color: ${({ theme }) => theme.globalConstants.color.textLight};
  border: ${({ theme, isDelete }) =>
    isDelete
      ? `1px solid ${theme.globalConstants.color.borderDanger}`
      : `1px solid ${theme.globalConstants.color.borderPrimary}`};
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
    cursor: not-allowed;
  }
`;
